import { FinancialStatementAccount } from 'src/app/domain/financial-statement/models/common/FinancialStatementAccount';
import { GeneralLedgerTransactionDTO } from '../DTOs/common/GeneralLedgerTransactionDTO';

export class GeneralLedgerTransaction {
  public constructor(
    public id: number,
    public transactionDate: Date,
    public journalEntryCode: string,
    public account: FinancialStatementAccount,
    public contraAccount: FinancialStatementAccount,
    public description?: string,
    public comment?: string,
    public debit?: number,
    public credit?: number,
    public isManualEntry?: boolean,
    public isMarkedForConversion?: boolean,
    // The below properties are not saved and are calculated on front
    public isSelected?: boolean,
    public isSelectedForDelete?: boolean,
  ) {}

  static toDTO(transaction: GeneralLedgerTransaction): GeneralLedgerTransactionDTO {
    return new GeneralLedgerTransactionDTO(
      transaction.id ?? 0,
      transaction.transactionDate,
      transaction.journalEntryCode,
      transaction.description,
      transaction.comment,
      transaction.debit,
      transaction.credit,
      transaction.isManualEntry,
      transaction.isMarkedForConversion,
      transaction.account.id,
      transaction.contraAccount.id,
    );
  }

  makeCopy(): GeneralLedgerTransaction {
    return new GeneralLedgerTransaction(
      0,
      this.transactionDate,
      '',
      this.account,
      this.contraAccount,
      this.description,
      this.comment,
      this.debit,
      this.credit,
      this.isManualEntry,
      this.isMarkedForConversion,
    );
  }

}
